import { Card, Skeleton } from '@execonline-inc/execonline-ui';

function PopularCompetenciesSkeleton() {
  return (
    <>
      <Skeleton className="h-5 w-1/3 mb-4 mr-4" />
      <Card className="pl-[5%] pt-[3%] pr-[5%] pb-[3%]" radius="lg">
        <div className="flex justify-between">
          <Skeleton variant="text" className="w-20 h-6" />
          <Skeleton variant="text" className="w-16 h-6" />
        </div>
        {[...Array(5)].map((_, index) => (
          <div className="flex justify-between mt-4" key={index}>
            <div className="flex items-center">
              <Skeleton variant="text" className="w-24 h-6" />
            </div>
            <Skeleton variant="text" className="w-16 h-6" />
          </div>
        ))}
      </Card>
    </>
  );
}

export default PopularCompetenciesSkeleton;
